import { render, staticRenderFns } from "./ChildsEffectivinessChart.vue?vue&type=template&id=0eb604d6"
import script from "./ChildsEffectivinessChart.vue?vue&type=script&lang=js"
export * from "./ChildsEffectivinessChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports